'use client';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import useWindowSize from '@/presentation/hooks/useWindowSize';
import SidebarVertical from './SidebarVertical';
import SidebarHorizontal from './SidebarHorizontal';
import { Page } from './types';

const SidebarContainer = () => {
  const pathname = usePathname();

  const activePage = useMemo(() => {
    const path = pathname.split('/');

    if (path.includes('profile')) {
      return 'profile';
    }

    return path.pop() || 'profile';
  }, [pathname]) as Page;

  const { width } = useWindowSize();

  if (!width || width >= 640) {
    return <SidebarVertical activePage={activePage} />;
  }

  return <SidebarHorizontal activePage={activePage} />;
};

export default SidebarContainer;
